import { computed } from 'vue'
import { useStore } from 'vuex'

import { userCapabilities } from '@/composables/useSettingsAccess'

export const FULFILLMENT_WIZARD_CAPABILITY = 'fulfillment-method-wizard'

export const hasFulfillmentWizard = user => userCapabilities(user).includes(FULFILLMENT_WIZARD_CAPABILITY)

export function useFulfillmentWizardAccess() {
  const store = useStore()
  return computed(() => hasFulfillmentWizard(store.state.loggedInUser))
}
